<template>
  <div class="komodo-level">
    <slot />
  </div>
</template>

<script lang="ts">
export default {
  name: 'KomodoLevel'
}
</script>

<script setup lang="ts">
</script>

<style lang="scss" scoped>
.komodo-level {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: space-between;
}
</style>
